"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_TEST_IDS = void 0;
var DATA_TEST_IDS;
(function (DATA_TEST_IDS) {
    DATA_TEST_IDS["TASK_LIST"] = "TaskList";
    DATA_TEST_IDS["TASK_LIST_HEADER"] = "TaskListHeader";
    DATA_TEST_IDS["TASK_LIST_NAV"] = "TaskListNav";
    DATA_TEST_IDS["TASK_LIST_BACK_BTN"] = "TaskListBackBtn";
    DATA_TEST_IDS["TASK_LIST_TITLE"] = "TaskListTitle";
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION"] = "TaskListDescription";
    DATA_TEST_IDS["TASK_LIST_DESCRIPTION_MODAL"] = "TaskListDescriptionModal";
    DATA_TEST_IDS["TASK_LIST_ADDRESS_BEFORE"] = "TaskListAddressBefore";
    DATA_TEST_IDS["TASK_LIST_ITEMS"] = "TaskListItems";
    DATA_TEST_IDS["TASK_LIST_EMPTY_STATE"] = "TaskListEmptyState";
    DATA_TEST_IDS["TASK_LIST_ITEMS_REQUIRE_ATTENTION"] = "TaskListItems-RequireAttention";
    DATA_TEST_IDS["TLI_RA_ITEM_CARD"] = "TaskListItems-RequireAttention-ItemCard";
    DATA_TEST_IDS["TLI_RA_ITEM_CARD_ACTION_BUTTON"] = "TaskListItems-RequireAttention-ItemCard-ActionButton";
    DATA_TEST_IDS["TLI_RA_DUPLICATED_PUNCHES"] = "TaskListItems-RequireAttention-DuplicatedPunches";
    DATA_TEST_IDS["TLI_RA_MISSING_PUNCHES"] = "TaskListItems-RequireAttention-MissingPunches";
    DATA_TEST_IDS["TLI_RA_SYSTEM_ADDED_PUNCHES"] = "TaskListItems-RequireAttention-SystemAddedPunches";
    DATA_TEST_IDS["TLI_RA_ITEMS"] = "TaskListItems-RequireAttention-Items";
    DATA_TEST_IDS["TLI_PCA_ITEM_CARD"] = "TaskListItems-PunchCorrectionStatus-ItemCard";
})(DATA_TEST_IDS = exports.DATA_TEST_IDS || (exports.DATA_TEST_IDS = {}));
